// submittedTime is written with Date.now(): milliseconds since the Unix epoch.
export function orderSubmissionDate(value) {
    if (typeof value !== 'number' || !Number.isFinite(value)) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function archiveEligibility(order, quarter, year) {
    if (![order.userId, order.clientId, order.id].every(value => typeof value === 'string' && value && !value.includes('/'))) return 'invalidPath';
    const date = orderSubmissionDate(order.submittedTime);
    if (!date) return 'invalidDate';
    return date >= new Date(year, (quarter - 1) * 3, 1) && date < new Date(year, quarter * 3, 1) ? 'move' : 'outside';
}

export function sweepOrders(orders, quarter, year) {
    const result = { move: [], outside: [], invalidDate: [], invalidPath: [] };
    const seen = new Set();
    for (const order of orders) {
        const key = JSON.stringify([order.userId, order.clientId, order.id]);
        if (seen.has(key)) continue;
        seen.add(key);
        result[archiveEligibility(order, quarter, year)].push(order);
    }
    return result;
}

export async function archiveOrder(database, order, quarter, year) {
    if (archiveEligibility(order, quarter, year) !== 'move') return 'skipped';
    const base = `Customers/${order.userId}/clients/${order.clientId}`;
    const source = database.doc(`${base}/active/${order.id}`);
    const destination = database.doc(`${base}/archive_Q${quarter}_${year}/${order.id}`);
    return database.runTransaction(async transaction => {
        const snapshot = await transaction.get(source);
        if (!snapshot.exists) return 'missing';
        if (archiveEligibility({ ...snapshot.data(), userId: order.userId, clientId: order.clientId, id: order.id }, quarter, year) !== 'move') return 'skipped';
        // Preserve an existing archive rather than silently overwriting it.
        const archived = await transaction.get(destination);
        if (archived.exists) return 'conflict';
        transaction.set(destination, snapshot.data());
        transaction.delete(source);
        return 'moved';
    });
}
